


























import { PropType, computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { SfButton, SfImage, SfLink } from '@storefront-ui/vue';
import { useHoverImage, useProduct } from '~/composables';
import { getName as getProductName, getPrice as getProductPrice } from '~/modules/catalog/product/getters/productGetters';
import { CustomProduct } from '~/modules/catalog/types';
import SvgImage from '../General/SvgImage.vue';
import HTMLContent from '../HTMLContent.vue';
import ImageWithHover from '../ImageWithHover.vue';

export default defineComponent({
  name: 'PackageCard',
  components: {
    SfButton,
    SfLink,
    SfImage,
    HTMLContent,
    SvgImage,
    ImageWithHover,
  },
  props: {
    product: {
      type: Object as PropType<CustomProduct>,
      required: true,
    },
  },
  setup(props) {
    const qty = ref(1);
    const { isHovered, hoverImage, unhoverImage } = useHoverImage();
    const { getProductPath } = useProduct();

    const productPrice = computed(() => getProductPrice(props.product).regular);

    return {
      qty,
      isHovered,
      getProductName,
      productPrice,
      getProductPath,
      hoverImage,
      unhoverImage,
    };
  },
});
